<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg990"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs994"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1004"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1002" /></clipPath></defs><g
     id="g996"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g998"><g
         id="g1000"
         clip-path="url(#clipPath1004)"><g
           id="g1006"
           transform="translate(247.9839,390.2153)"><path
             d="m 0,0 -104.209,-60.166 c -4.961,-2.863 -8.017,-8.156 -8.017,-13.884 v -120.331 c 0,-5.727 3.056,-11.02 8.017,-13.884 L 0,-268.431 c 4.96,-2.863 11.072,-2.863 16.033,0 l 104.209,60.166 c 4.961,2.864 8.016,8.157 8.016,13.884 V -74.05 c 0,5.728 -3.055,11.021 -8.016,13.884 L 16.032,0 C 11.072,2.864 4.96,2.864 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1008" /></g><g
           id="g1010"
           transform="translate(140.5469,322.6572)"><path
             d="m 0,0 115.453,-66.657 86.67,50.039"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1012" /></g><g
           id="g1014"
           transform="translate(256,119.7256)"><path
             d="M 0,0 V 136.274"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1016" /></g><g
           id="g1018"
           transform="translate(280.0488,480.4517)"><path
             d="m 0,0 c 0,13.282 -10.768,24.048 -24.049,24.048 -13.282,0 -24.048,-10.766 -24.048,-24.048 0,-13.282 10.766,-24.048 24.048,-24.048 C -10.768,-24.048 0,-13.282 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1020" /></g><g
           id="g1022"
           transform="translate(472.4355,368.2256)"><path
             d="M 0,0 C 0,13.282 -10.767,24.049 -24.049,24.049 -37.33,24.049 -48.097,13.282 -48.097,0 c 0,-13.281 10.767,-24.048 24.048,-24.048 C -10.767,-24.048 0,-13.281 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1024" /></g><g
           id="g1026"
           transform="translate(472.4355,143.7744)"><path
             d="M 0,0 C 0,13.281 -10.767,24.048 -24.049,24.048 -37.33,24.048 -48.097,13.281 -48.097,0 c 0,-13.282 10.767,-24.049 24.048,-24.049 C -10.767,-24.049 0,-13.282 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1028" /></g><g
           id="g1030"
           transform="translate(280.0488,31.5483)"><path
             d="m 0,0 c 0,13.282 -10.768,24.048 -24.049,24.048 -13.282,0 -24.048,-10.766 -24.048,-24.048 0,-13.282 10.766,-24.048 24.048,-24.048 C -10.768,-24.048 0,-13.282 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1032" /></g><g
           id="g1034"
           transform="translate(87.6611,143.7744)"><path
             d="M 0,0 C 0,13.281 -10.767,24.048 -24.048,24.048 -37.33,24.048 -48.097,13.281 -48.097,0 c 0,-13.282 10.767,-24.049 24.049,-24.049 C -10.767,-24.049 0,-13.282 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1036" /></g><g
           id="g1038"
           transform="translate(87.6611,368.2256)"><path
             d="M 0,0 C 0,13.282 -10.767,24.049 -24.048,24.049 -37.33,24.049 -48.097,13.282 -48.097,0 c 0,-13.281 10.767,-24.048 24.049,-24.048 C -10.767,-24.048 0,-13.281 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1040" /></g><g
           id="g1042"
           transform="translate(207.4424,452.4165)"><path
             d="M 0,0 -95.79,-55.304"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1044" /></g><g
           id="g1046"
           transform="translate(400.3467,397.1128)"><path
             d="M 0,0 -95.789,55.304"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1048" /></g><g
           id="g1050"
           transform="translate(450.3809,199.7861)"><path
             d="M 0,0 V 112.428"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1052" /></g><g
           id="g1054"
           transform="translate(304.5576,59.5835)"><path
             d="M 0,0 95.789,55.304"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1056" /></g><g
           id="g1058"
           transform="translate(111.6533,114.8877)"><path
             d="M 0,0 95.789,-55.304"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1060" /></g><g
           id="g1062"
           transform="translate(61.6191,312.2139)"><path
             d="M 0,0 V -112.428"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1064" /></g><g
           id="g1066"
           transform="translate(316.2266,359.9829)"><path
             d="m 0,0 -119.93,-69.284 v -42.962"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1068" /></g></g></g></g></svg>
</template>
